import React, { Component } from 'react';

import './MerchCategorySquare.css';

class MerchCategorySquare extends Component {
    constructor(props) {
        super(props);

        this.state = {
          selected: this.props.selected
        };

        //bind methods
        this.toggleSelected = this.toggleSelected.bind(this);
    }

    toggleSelected() {
        if (!this.state.selected) {
            // Return it to our parent component
            this.props.selectCategory(this.props.object);
        } else {
            this.props.unselectCategory(this.props.object);
        }

        // Flip it
        this.setState({
           selected: !this.state.selected
        });
    }

    render() {
        return (
          <div onClick={this.toggleSelected} className={this.state.selected ? 'MerchCategorySquare selected' : 'MerchCategorySquare'}>
              <p className="noselect">{this.props.name}</p>
          </div>
        );
    }
}

export default MerchCategorySquare;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/SelectCategoriesStep/components/MerchCategorySquare.js